import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function HomeIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.73133 12.6874C8.10599 14.1431 9.42739 15.2187 11 15.2187C12.5726 15.2187 13.894 14.1431 14.2687 12.6874M10.1712 3.20707L4.44861 7.65796C4.06608 7.95548 3.87482 8.10424 3.73702 8.29054C3.61496 8.45557 3.52404 8.64148 3.46871 8.83915C3.40625 9.06229 3.40625 9.3046 3.40625 9.78921V15.8937C3.40625 16.8388 3.40625 17.3113 3.59018 17.6723C3.75196 17.9898 4.01012 18.248 4.32764 18.4098C4.68862 18.5937 5.16116 18.5937 6.10625 18.5937H15.8938C16.8388 18.5937 17.3114 18.5937 17.6724 18.4098C17.9899 18.248 18.248 17.9898 18.4098 17.6723C18.5937 17.3113 18.5938 16.8388 18.5938 15.8937V9.78921C18.5938 9.3046 18.5937 9.06229 18.5313 8.83915C18.476 8.64148 18.385 8.45557 18.263 8.29054C18.1252 8.10424 17.9339 7.95548 17.5514 7.65796L11.8288 3.20707C11.5324 2.97651 11.3842 2.86123 11.2205 2.81692C11.0761 2.77782 10.9239 2.77782 10.7795 2.81692C10.6158 2.86123 10.4676 2.97651 10.1712 3.20707Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
